<template>
	<form class="new-event-flight-reservation__online-form" @submit.prevent="goToWoobaFlightsPage">
		<section class="new-event-flight-reservation__form-intro">
			<button type="button" class="new-event-flight-reservation__toggle" :aria-label="translation.flightReservationTitle">
				<span></span>
			</button>
			<h3>{{translation.flightReservationTitle}}</h3>
		</section>

		<div class="new-event-flight-reservation__online-grid">
			<div class="new-event-flight-reservation__field">
				<label>{{translation.origin}}</label>
				<autocomplete
					v-model="reservation.origin"
					class="new-event-flight-reservation__autocomplete"
					:class="{'new-event-flight-reservation__input--invalid': touched && !reservation.origin}"
					:options="debounce(findAirports, 300)"
					track-by="initials"
					label-by="label"
					:placeholder="translation.originPlaceholder"
				/>
			</div>

			<div class="new-event-flight-reservation__field">
				<label>{{translation.destination}}</label>
				<autocomplete
					v-model="reservation.destination"
					class="new-event-flight-reservation__autocomplete"
					:class="{'new-event-flight-reservation__input--invalid': touched && !reservation.destination}"
					:options="debounce(findAirports, 300)"
					track-by="initials"
					label-by="label"
					:placeholder="translation.destinationPlaceholder"
				/>
			</div>

			<div class="new-event-flight-reservation__field">
				<label>{{translation.departureDate}}</label>
				<date-picker
					v-model="reservation.checkin"
					class="new-event-flight-reservation__date"
					:initialDefaultDate="initialDefaultDate"
					:invalid="touched && !reservation.checkin"
				/>
			</div>

			<div class="new-event-flight-reservation__field">
				<label>{{translation.returnDate}}</label>
				<date-picker
					v-model="reservation.checkout"
					class="new-event-flight-reservation__date"
					:initialDefaultDate="initialDefaultDate"
				/>
			</div>

			<div class="new-event-flight-reservation__passengers">
				<div class="new-event-flight-reservation__counter">
					<label>{{translation.adults}}</label>
					<blm-number-input v-model="reservation.adults" :min="1" :max="9"/>
				</div>
				<div class="new-event-flight-reservation__counter">
					<label>{{translation.children}}</label>
					<blm-number-input v-model="reservation.kids" :min="0" :max="9"/>
				</div>
				<div class="new-event-flight-reservation__counter">
					<label>{{translation.babies}}</label>
					<blm-number-input v-model="reservation.babies" :min="0" :max="9"/>
				</div>
			</div>
		</div>

		<div class="new-event-flight-reservation__actions">
			<button type="button" class="new-event-flight-reservation__button new-event-flight-reservation__button--secondary" @click="$emit('close')">
				voltar
			</button>
			<button type="submit" class="new-event-flight-reservation__button new-event-flight-reservation__button--primary">
				{{translation.continueButton}}
			</button>
		</div>
	</form>
</template>

<script>
import debounce from 'debounce-promise';
import moment from 'moment';
import { translate } from '../../assets/translations';
import AirportService from '../../services/AirportService';
import Autocomplete from '../shared/Autocomplete.vue';
import BlmNumberInput from '../shared/BlmNumberInput.vue';
import DatePicker from '../shared/DatePicker.vue';

export default {
	components: {
		Autocomplete,
		BlmNumberInput,
		DatePicker,
	},
	props: {
		event: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			airportService: new AirportService(),
			touched: false,
			reservation: {
				origin: undefined,
				destination: undefined,
				checkin: null,
				checkout: null,
				adults: 1,
				kids: 0,
				babies: 0,
			},
		};
	},
	computed: {
		initialDefaultDate() {
			return this.event && this.event.startDate
				? moment(this.event.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
				: moment().format('DD/MM/YYYY');
		},
		reservationParams() {
			return {
				shortName: this.event.shortName,
				event: this.event,
				...this.reservation,
				origin: this.reservation.origin.initials,
				destination: this.reservation.destination.initials,
				checkin: moment(this.reservation.checkin).format('DD/MM/YYYY'),
				checkout: this.reservation.checkout ? moment(this.reservation.checkout).format('DD/MM/YYYY') : null,
			};
		},
		translation() {
			return translate(this.$store.state.language).flightReservation;
		},
	},
	methods: {
		debounce,
		findAirports(query) {
			return this.airportService.findAirports(query).then(response => response.data);
		},
		goToWoobaFlightsPage() {
			this.touched = true;
			if (!this.reservation.origin || !this.reservation.destination || !this.reservation.checkin || this.reservation.adults < 1) return;
			this.$router.push({ name: 'flight-reservation', params: this.reservationParams });
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/flight-reservation/FlightRequestOnline.vue